import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as Constants from './constants'
import * as brActions from './actions'
const getBacLuongState = state => state.bacLuong;

function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then( function(response){
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function listRequestApi (formData) {
  const request = axiosApi().post(
    Constants.BACLUONG_LIST_API, 
    formData
  )

  return handleRequest(request);
}
function userListRequestApi (formData) {
  const request = axiosApi().post(
    Constants.BACLUONG_USER_LIST_API, 
    formData
  )

  return handleRequest(request);
}
function detailRequestApi (formData) {
  const request = axiosApi().post(
    Constants.BACLUONG_DETAIL_API, 
    formData
  )

  return handleRequest(request);
}
function userDetailRequestApi (formData) {
  const request = axiosApi().post(
    Constants.BACLUONG_USER_DETAIL_API, 
    formData
  )

  return handleRequest(request);
}
function bacLuongUpdateRequestApi (formData) {
  const request = axiosApi().post(
    Constants.BACLUONG_UPDATE_API, 
    formData
  )

  return handleRequest(request);
}
function bacLuongUserUpdateRequestApi (formData) {
  const request = axiosApi().post(
    Constants.BACLUONG_USER_UPDATE_API, 
    formData
  )

  return handleRequest(request);
}

function* bacLuongListRequestFlow () {
  const bacLuong = yield select(getBacLuongState);
  try {
    // grab the client from our action
    const results = yield call(listRequestApi, bacLuong.formData)

    // dispatch the action with our widgets!
    yield put(brActions.bacLuongListSuccess(results.data))

  } catch (error) {
    yield put(brActions.bacLuongListError(error))
  }
}

function* bacLuongUserListRequestFlow () {
  const bacLuong = yield select(getBacLuongState);
  try {
    // grab the client from our action
    const results = yield call(userListRequestApi, bacLuong.formData)

    // dispatch the action with our widgets!
    yield put(brActions.bacLuongUserListSuccess(results.data))

  } catch (error) {
    yield put(brActions.bacLuongUserListError(error))
  }
}

function* bacLuongDetailRequestFlow () {
  const bacLuong = yield select(getBacLuongState);
  try {
    // grab the client from our action
    const results = yield call(detailRequestApi, bacLuong.formData)

    // dispatch the action with our widgets!
    yield put(brActions.bacLuongDetailSuccess(results.data))

  } catch (error) {
    yield put(brActions.bacLuongDetailError(error))
  }
}

function* bacLuongUserDetailRequestFlow () {
  const bacLuong = yield select(getBacLuongState);
  try {
    // grab the client from our action
    const results = yield call(userDetailRequestApi, bacLuong.formData)

    // dispatch the action with our widgets!
    yield put(brActions.bacLuongUserDetailSuccess(results.data))

  } catch (error) {
    yield put(brActions.bacLuongUserDetailError(error))
  }
}

function* bacLuongUpdateRequestFlow (action) {
  const bacLuong = yield select(getBacLuongState);
  try {
    // grab the client from our action
    const result = yield call(bacLuongUpdateRequestApi, bacLuong.formData)

    // dispatch the action with our widgets!
    yield put(brActions.bacLuongUpdateSuccess(result));
  } catch (error) {
    yield put(brActions.bacLuongUpdateError(error))
  }
}

function* bacLuongUserUpdateRequestFlow (action) {
  const bacLuong = yield select(getBacLuongState);
  try {
    // grab the client from our action
    const result = yield call(bacLuongUserUpdateRequestApi, bacLuong.formData)

    // dispatch the action with our widgets!
    yield put(brActions.bacLuongUserUpdateSuccess(result));
  } catch (error) {
    yield put(brActions.bacLuongUserUpdateError(error))
  }
}

function* bacLuongWatcher () {
  yield [
    takeLatest(Constants.BACLUONG_LIST_REQUESTING, bacLuongListRequestFlow),
    takeLatest(Constants.BACLUONG_DETAIL_REQUESTING, bacLuongDetailRequestFlow),
    takeLatest(Constants.BACLUONG_UPDATE_REQUESTING, bacLuongUpdateRequestFlow),
    takeLatest(Constants.BACLUONG_USER_DETAIL_REQUESTING, bacLuongUserDetailRequestFlow),
    takeLatest(Constants.BACLUONG_USER_UPDATE_REQUESTING, bacLuongUserUpdateRequestFlow),
    takeLatest(Constants.BACLUONG_USER_LIST_REQUESTING, bacLuongUserListRequestFlow),
  ]
}

export default bacLuongWatcher



// WEBPACK FOOTER //
// ./src/views/BacLuong/sagas.js